export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9021.19618dfe.jpg";